import { render, staticRenderFns } from "./graphics_designer.vue?vue&type=template&id=1c0fabf0&slot=default&slot-scope=%7B%20hide%20%7D"
import script from "./graphics_designer.vue?vue&type=script&lang=js"
export * from "./graphics_designer.vue?vue&type=script&lang=js"
import style0 from "./graphics_designer.vue?vue&type=style&index=0&id=1c0fabf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports